<nav
  [class]="
    'bg-primary-lighter border-b border-primary-light w-full ' + position
  "
>
  <div
    class="bg-gradient-to-t from-primary to-primary-light h-1 progress-value"
  ></div>
</nav>
